import { Typography } from 'darrius';

import styles from './SelectField.module.scss';

interface ISelectFieldProps {
  title: string;
  description: string;
  handleClickCard?: () => void;
}

export const SelectField = ({
  title,
  description,
  handleClickCard,
}: ISelectFieldProps) => {
  return (
    <button
      type="button"
      className={styles['select-field']}
      onClick={handleClickCard}
    >
      <div className={styles['subcategories']}>
        <Typography.Subtitle size="l" className={styles['title']}>
          {title}
        </Typography.Subtitle>
        <Typography.Text className={styles['text']}>
          {description}
        </Typography.Text>
      </div>
    </button>
  );
};
